// extracted by mini-css-extract-plugin
export default {"wrapper":"bkLyFlRzEbJmKUKwcvnb","content":"AKXZTPohs0m6dO7lzyW7"};